import httpClient from '@/services/httpClient';
import { unwrapEnvelope } from '@/services/api/helpers';

const SESSION_KEYS = ['authToken', 'name', 'email', 'actor'];

function decodeToken(token) {
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(decodeURIComponent(atob(payload).split('').map((char) => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`).join('')));
  } catch (_) {
    return null;
  }
}

export function clearSession() {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  localStorage.removeItem('vuex');
}

export function getStoredSession() {
  const token = localStorage.getItem('authToken');
  if (!token) return null;
  const claims = decodeToken(token);
  const actor = claims?.Actor || claims?.actor || localStorage.getItem('actor');
  const expiresAt = Number(claims?.exp || 0) * 1000;
  if (!claims || actor !== 'Employer' || (expiresAt && expiresAt <= Date.now())) {
    clearSession();
    return null;
  }
  return { token, actor, name: localStorage.getItem('name') || '', email: localStorage.getItem('email') || '' };
}

export function saveSession(data) {
  const token = data?.token;
  const claims = token ? decodeToken(token) : null;
  const actor = claims?.Actor || claims?.actor;
  if (!token || actor !== 'Employer') throw new Error('This portal requires an employer account.');
  localStorage.setItem('authToken', token);
  localStorage.setItem('actor', actor);
  localStorage.setItem('name', data.name || 'Employer');
  localStorage.setItem('email', data.email || '');
  return getStoredSession();
}

export async function login(email, password) {
  const response = await httpClient.post('/Employer/Login', { email, password });
  return saveSession(unwrapEnvelope(response.data));
}

export default { login, getStoredSession, saveSession, clearSession };
